var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import DropdownRegistry from './DropdownRegistry';
import { canUseDOM } from 'exenv';

var Dropdown = function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  _createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        dropdownRegistry: this.dropdownRegistry
      };
    }
  }]);

  function Dropdown(props, context) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props, context));

    _this.dropdownRegistry = new DropdownRegistry();
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleDocumentKeydown = _this.handleDocumentKeydown.bind(_this);
    return _this;
  }

  _createClass(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (canUseDOM) {
        global.document.addEventListener('keydown', this.handleDocumentKeydown);
        global.document.addEventListener('click', this.handleDocumentClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (canUseDOM) {
        global.document.removeEventListener('keydown', this.handleDocumentKeydown);
        global.document.removeEventListener('click', this.handleDocumentClick);
      }
    }
  }, {
    key: 'handleDocumentKeydown',
    value: function handleDocumentKeydown(event) {
      var keyCode = event.keyCode;

      if (keyCode === 40) {
        // down
        event.preventDefault();
        this.dropdownRegistry.focusNext();
      } else if (keyCode === 38) {
        // up
        event.preventDefault();
        this.dropdownRegistry.focusPrev();
      } else if (keyCode === 27) {
        // esc
        this.props.onClose();
      }
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick() {
      this.props.onClose();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'ul',
        {
          role: 'menu',
          className: 'cf-dropdown cf-dropdown--' + this.props.align
        },
        this.props.children
      );
    }
  }]);

  return Dropdown;
}(React.Component);

Dropdown.propTypes = {
  onClose: PropTypes.func.isRequired,
  align: PropTypes.oneOf(['left', 'right']),
  children: PropTypes.node
};

Dropdown.defaultProps = {
  align: 'left'
};

Dropdown.childContextTypes = {
  dropdownRegistry: PropTypes.instanceOf(DropdownRegistry).isRequired
};

export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-dropdown/es/Dropdown.js
// module id = 1143
// module chunks = 0